export default function ChevronDown() {
  return (
    <svg
      width="11"
      height="7"
      viewBox={`0 0 11 7`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.09375 6.53125L0.84375 2.28125C0.53125 1.96875 0.53125 1.5 0.84375 1.21875L1.53125 0.5C1.84375 0.21875 2.3125 0.21875 2.59375 0.5L5.59375 3.53125L8.625 0.5C8.90625 0.21875 9.375 0.21875 9.6875 0.5L10.375 1.21875C10.6875 1.5 10.6875 1.96875 10.375 2.28125L6.125 6.53125C5.84375 6.8125 5.375 6.8125 5.09375 6.53125Z"
        fill="currentColor"
      />
    </svg>
  );
}
